var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoPetangeWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 290 180.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_petange_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "10.44 167.92 6.51 172.83 2.6 167.92 1.01 167.92 1.01 179.85 2.7 179.85 2.7 170.57 2.74 170.57 6.37 175.18 6.65 175.18 10.28 170.57 10.32 170.57 10.32 179.85 12.01 179.85 12.01 167.92 10.44 167.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,167.77a6.12,6.12,0,1,1,0,12.24,6.12,6.12,0,1,1,0-12.24m0,10.67a4.55,4.55,0,1,0,0-9.1,4.55,4.55,0,1,0,0,9.1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "37.82 167.92 37.82 169.47 41.9 169.47 41.9 179.85 43.6 179.85 43.6 169.47 47.68 169.47 47.68 167.92 37.82 167.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.87,
    y: 167.92,
    width: 1.7,
    height: 11.93,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.23 167.92 68.7 176.3 65.15 167.92 63.45 167.92 68.56 179.96 68.9 179.96 73.9 167.92 72.23 167.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.74,170.48l1.9,4.32H82Zm-.57-2.63-5.07,12h1.73l1.49-3.52h5l1.57,3.52h1.73l-5.28-12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.78 167.92 93.78 169.47 97.86 169.47 97.86 179.85 99.56 179.85 99.56 169.47 103.64 169.47 103.64 167.92 93.78 167.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.82,
    y: 167.92,
    width: 1.7,
    height: 11.93,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.52,167.77a6.12,6.12,0,1,1-6.34,6.12,6,6,0,0,1,6.34-6.12m0,10.67a4.55,4.55,0,1,0-4.58-4.55,4.45,4.45,0,0,0,4.58,4.55",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.85 167.92 149.85 177.16 141.86 167.92 140.51 167.92 140.51 179.85 142.1 179.85 142.1 170.67 149.99 179.85 151.45 179.85 151.45 167.92 149.85 167.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.05,170.58a7.67,7.67,0,0,0-4.07-1.24,4.51,4.51,0,0,0-4.71,4.56,4.44,4.44,0,0,0,4.78,4.53,7.72,7.72,0,0,0,4.12-1.35V179a8.6,8.6,0,0,1-4.28,1.05,6.06,6.06,0,0,1-6.37-5.95,6.18,6.18,0,0,1,6.47-6.3,10.22,10.22,0,0,1,4,1v1.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.64,167.77a6.12,6.12,0,1,1-6.34,6.12,6,6,0,0,1,6.34-6.12m0,10.67a4.55,4.55,0,1,0-4.59-4.55,4.45,4.45,0,0,0,4.59,4.55",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.04 167.92 213.11 172.83 209.2 167.92 207.61 167.92 207.61 179.85 209.3 179.85 209.3 170.57 209.34 170.57 212.97 175.18 213.25 175.18 216.88 170.57 216.92 170.57 216.92 179.85 218.61 179.85 218.61 167.92 217.04 167.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.13 167.92 232.2 172.83 228.29 167.92 226.7 167.92 226.7 179.85 228.39 179.85 228.39 170.57 228.43 170.57 232.06 175.18 232.34 175.18 235.97 170.57 236.01 170.57 236.01 179.85 237.7 179.85 237.7 167.92 236.13 167.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.74,175.17c0,2.92-1.73,4.84-5.24,4.84-2.49,0-4.91-1.41-4.91-4.67v-7.42h1.7V175c0,1.35.18,1.91.71,2.45a3.45,3.45,0,0,0,2.55,1,3.85,3.85,0,0,0,2.77-1,3.49,3.49,0,0,0,.74-2.61v-6.94h1.7v7.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.97 167.92 272.97 177.16 264.98 167.92 263.63 167.92 263.63 179.85 265.22 179.85 265.22 170.67 273.11 179.85 274.57 179.85 274.57 167.92 272.97 167.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.74 167.92 282.74 179.85 289.59 179.85 289.59 178.32 284.43 178.32 284.43 174.61 289.26 174.61 289.26 173.07 284.43 173.07 284.43 169.47 289.44 169.47 289.44 167.92 282.74 167.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.86,118.06c0,6.1-4.19,9.48-8.88,9.23V110.1c5.36,0,8.88,2.47,8.88,8m7.12-.25c-.34-7.79-5.53-10.67-17-10.5L5,107.4l-4.52-.09,4.1.09L0,107.31v2.29c3.52,0,4,.93,4,3.39v31.75c0,2.79-.33,3.64-3.94,3.64v2.2l4.53-.09H9.89l4.69.09v-2.2c-3.6,0-3.6-.68-3.6-3.81V130.26c8.29.5,16.34-4.66,16-12.45",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.59,118.23c0,2.37-.92,2.54-6,2.54H48.09c.17-5.34,3.1-10.67,7.79-10.84,5-.16,7.71,4.58,7.71,8.3m2-28.87h-8L52.1,99.44l3.35,1Zm3.86,47.93-.67-2.2C53,141.36,48.17,130,48.17,123.91c5.86-.08,13.74-.17,19.27-.08,1.09,0,1.84-.17,1.93-2.54.33-7.45-4.77-14.3-13-14.14-7.62.09-14.83,6.69-14.83,17.53,0,9.3,8.12,22.17,27.89,12.61",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.79,132.88V110.53h-4v-2.45c4.19-.77,5.7-3.3,7-7.45h3.94v6.68h10v3.22h-10v19.14c0,4.23-.84,9.65,10,5.84l.83,2.54c-16.25,7.36-17.84.34-17.84-5.17",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.55,133.39c-7.54,5.93-11.23,1.7-11.23-1.61,0-4.23,3.69-6.52,11.23-6.6ZM150.28,138,149,136.18c-4.11,2.71-4.52-.68-4.52-3.73v-18c0-4.91-2.26-7.62-8.71-7.45-5.44.17-12,3.21-14.32,6.26-1.09,1.61-1.84,4.49.25,4.57,1.42.08,5.36-1.1,5.36-2.2,0-3.3,2.93-5.67,7.7-5.76,2.77,0,2.77,1.78,2.77,6.18v6.18c-11.56-.26-17.93,4.66-18.18,10.49s6.11,13,18.35,4c0,2.9,5.11,7.05,12.56,1.37",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.28,114.34v25.91h-3.35c-2.26-2.71-16.83-17.69-21-23.28v14.31c0,5.76.5,6.43,3.77,6.43V140l-4.36-.17h-3.18l-4.36.17v-2.29c3.27,0,3.77-.93,3.77-6.77V115.19c0-4.57-.67-5.58-4.69-5.58v-2.29l4.19.09,4.69-.09c2,2.46,15.5,16.68,20.18,22.27V114.18c0-3.47-.5-4.57-3.52-4.57v-2.29l4.1.09h3.27l4-.09v2.29c-2.91,0-3.5,1.09-3.5,4.73",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.14,118.23c0,2.37-.92,2.54-5.95,2.54h-9.55c.17-5.34,3.1-10.67,7.79-10.84,5-.16,7.71,4.58,7.71,8.3M290,137.29l-.67-2.2c-15.75,6.27-20.61-5.08-20.61-11.18,5.87-.08,13.74-.17,19.27-.08,1.09,0,1.84-.17,1.93-2.54.34-7.45-4.77-14.3-13-14.14-7.62.09-14.83,6.69-14.83,17.53,0,9.3,8.13,22.17,27.89,12.61",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.39,13.24a2.11,2.11,0,0,0-1.27-2.13c-1.33-.48-3.36.51-5.43,2.07,0-.08,0-.14,0-.23a10.34,10.34,0,0,1,.09-1.32h0A13.66,13.66,0,0,1,104.22.84L103.88,0c-9,3.18-10.3,4.83-12.33,7.33a32,32,0,0,1-7.82,7C69,24.52,63.83,24.64,51.4,24.92l-5.34.14L46,26l4.49,1.26c3.89,1.14,6.55,1.91,10.83,1.51a48.25,48.25,0,0,1-22.78,4l-2.82-.06-.14.89c7.46,2.34,16,4,28.2.17a59.25,59.25,0,0,0,9.29-4,76.78,76.78,0,0,1,7.89-3.61c1,3.53,6.12,5.83,13.23,5.78l.19-.87-1.93-.83c-2.47-1-4.31-1.74-4.31-4.2a5.49,5.49,0,0,1,0-.68c.12-1,2.2-4.51,5.18-7.85A27.64,27.64,0,0,1,96,14.86,3.86,3.86,0,0,0,97.41,17a3.62,3.62,0,0,0,3.83,0,4.1,4.1,0,0,0,2.15-3.73",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.35,36.08l.11-.88a60.31,60.31,0,0,0-12.84-3.13l-.68-.11c-6.31-1-10.05-2.64-11.4-5-1-1.68-.76-4.55,1.67-6.57L147,16.55c3.94-3,6.12-4.68,8.22-9.69l-.71-.52a101.71,101.71,0,0,1-11.93,9l-2.13,1.1c-1.55.8-3.07,1.6-4.5,2.2a3.17,3.17,0,0,0,.27-1.07,2.61,2.61,0,0,0-.23-1.06c-.68-1.48-2.72-2.32-4.74-2A3.7,3.7,0,0,0,128.17,17a2.46,2.46,0,0,0,.74,2.51,4.69,4.69,0,0,0,4.2.92c-1.51,1-4.44,2.76-5.2,3.18l-.9.51a62.85,62.85,0,0,1-11.92,5.65A75,75,0,0,1,106,31.93l-4.85,1-.07.86a14.43,14.43,0,0,0,6.26.7,47.08,47.08,0,0,0,10.39-1.88l1.2-.42c1.69-.61,2.6-.9,3.25-.42.19.14.31.91.38,1.37l.27,1.17a12.91,12.91,0,0,0,3,4.61c6.11,5.26,13.79,6.71,25.69,4.85l6.93-1.71-.09-.89-.4,0c-6.1-.37-14.23-.9-16.73-4.28,6.33.46,23.39-.74,24.16-.8",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,39A90.3,90.3,0,0,1,83.37,44,40.83,40.83,0,0,1,72,47.9a5,5,0,0,0,1.76-3,1.23,1.23,0,0,0,0-.39c-.15-.57-.7-1.24-2.46-1.2-2.11.05-4.51,1.15-5.36,2.46a1.86,1.86,0,0,0-.34,1,1.81,1.81,0,0,0,.11.58,2.53,2.53,0,0,0,1.58,1.42A6.45,6.45,0,0,0,69,49c-.23.14-.42.3-.67.44a56.21,56.21,0,0,1-11.61,3.43,79.05,79.05,0,0,1-10.86.34h-3.8l-.3.78c1,1,4.07,1.43,8,1.94l2,.27a11.75,11.75,0,0,1,5,1.86,3.81,3.81,0,0,1,2,3.24,4.59,4.59,0,0,1-.21,1.35,8.59,8.59,0,0,0-.35,2.45c0,2.3.91,5.53,5.2,8,2.62,1.55,15.57,7,17.3,7.37h0l.17,0,.22-.86c-5.26-2.56-8.65-6.72-9.25-11,4.92,2.43,17.6,6.72,18.17,6.91l.4-.8a49.44,49.44,0,0,1-9.72-9.3L77,61.59c-2.53-2.32-1.15-6.65.82-8.89a53.88,53.88,0,0,1,8.56-7.18c3.89-2.86,7.91-5.82,10.43-9.36l-.6-.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,127.52h-3.27l-6.06-.09v2.29c3,0,3.52,1.1,3.52,4.57v2.49a9.54,9.54,0,0,1-5.25.67c-6.87-.59-11.81-5.5-12.23-13.55-.59-9.4,4.77-14,10.81-14.22,4.11-.26,7.88.26,9.55,5.67h2.43l-.25-6.27a27.87,27.87,0,0,0-15.5-1.78,17.81,17.81,0,0,0-14.41,16.51c-.22,5.69,2.07,11.42,6.09,14,.52.28,1.35.82,2.05,1.14a24.32,24.32,0,0,0,10.87,2.27,19.49,19.49,0,0,0,5.7-.74v4.06c0,5.34-4.19,8.21-10,8.55-5.19.34-11.9-1.86-10.39-6.86.69-2.15,3.34-2.91,6.87-3.67-3.87-.94-8.31-2.86-12.2.66a6.84,6.84,0,0,0-1.36,2.42c-2.1,6.94,7.79,11.51,15.83,11.18,10.89-.34,17.67-6.35,17.67-14.73V127.49Z",
    style: {
      fill: "#fff"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPetangeWhite);
export default __webpack_public_path__ + "static/media/logo_petange_white.4319c1cbf648672b1e6db45c851e23e2.svg";
export { ForwardRef as ReactComponent };